import { Link, useHistory } from "react-router-dom";
import { useEffect, useState } from "react";

const Navbar = () => {
  const history = useHistory();
  const button_menu_target = () => {
    var uk = document.querySelector(".uk-hidden-small");

    if (uk.getAttribute("style").includes("0px")) {
      uk.style.display = "block";
      uk.style.border = "1px";
    } else if (uk.getAttribute("style").includes("1px")) {
      uk.style.display = "none";
      uk.style.border = "0px";
    }
  };
  var menu = document.getElementsByClassName("menu-item");

  const close_Nav = () => {
    if (document.querySelector("body").clientWidth < 600) {
      let nav = document.querySelector(".uk-hidden-small");
      nav.style.display = "none";
      nav.style.border = "0px";
    }
  };
  const [rtl, setRtl] = useState(localStorage.getItem("Language") == "rtl");
  const [fr, setFr] = useState(localStorage.getItem("Language") == "fr");

  useEffect(() => {
    var rtl = document.querySelector("body").getAttribute("class");
    if (rtl) {
      if (rtl.includes("rtl")) {
        setRtl(true);
      } else {
        setRtl(false);
      }
    }
  }, []);

  const ChangeEng = () => {
    if (localStorage.getItem("Language")) {
      localStorage.setItem("Language", "En");
      history.go(0);
    }
  };

  const ChangeAr = () => {
    localStorage.setItem("Language", "rtl");
    history.go(0);
  };

  const ChangeFr = () => {
    localStorage.setItem("Language", "fr");
    history.go(0);
  };

  return (
    <header>
      <div className="logo uk-text-center">
        <img
          style={{ transform: "scale(1.2) translateY(-87px)" }}
          src={require("../Assets/logo.png")}
          alt=""
        />
      </div>
      <section
        className="top-header"
        style={{ backgroundColor: "#fff", zIndex: "1" }}
      >
        <div className="uk-container uk-container-center">
          <div className="uk-grid">
            <div className="uk-width-large-1-3 uk-width-medium-1-2">
              <ul
                className="social uk-flex uk-flex-center"
                style={{
                  position: "absolute",
                  transform: "translateY(-20px)",
                }}
              >
                <li>
                  <a>
                    <img
                      class="social-image"
                      src={require("../Assets/images/facebook-footer-icon.PNG")}
                    />
                  </a>
                </li>
                <li>
                  <a>
                    <img
                      class="social-image"
                      src={require("../Assets/images/instagram-footer-icon.PNG")}
                      style={{
                        transform: "scale(1.15) translateY(0.8px)",
                      }}
                    />
                  </a>
                </li>
                <li>
                  <a>
                    <img
                      class="social-image"
                      src={require("../Assets/images/twitter-footer-icon.png")}
                    />
                  </a>
                </li>
                <li>
                  <a>
                    <img
                      class="social-image"
                      src={require("../Assets/images/linkedin-footer-icon.PNG")}
                    />
                  </a>
                </li>
              </ul>
            </div>
            <div className="uk-width-large-1-3 uk-hidden-medium"></div>
            <div className="uk-width-large-1-3 uk-width-medium-1-2 uk-text-center-medium">
              <ul className="search-lang" style={{ marginLeft: "90px" }}>
                <li className="langue">
                  <span
                    style={{
                      border: "2px solid #cba334",
                      borderRadius: "5px",
                      backgroundColor: "#cba334",
                      width: "30px",
                      padding: "4px",
                      color: "white",
                      padding: "4px 10px",
                    }}
                    className="qtranxs_flag_fr"
                  >
                    <span style={{ color: "#fff" }} onClick={ChangeAr}>
                      AR
                    </span>{" "}
                    |{" "}
                    <span style={{ color: "#fff" }} onClick={ChangeEng}>
                      ENG
                    </span>{" "}
                    |{" "}
                    <span style={{ color: "#fff" }} onClick={ChangeFr}>
                      FR
                    </span>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section
        className="bottom-header uk-hidden-small"
        id="menu-target"
        style={{ border: 0 }}
      >
        <div className="uk-container uk-container-center">
          <div className="uk-grid">
            <div className="uk-width-large-1-3 uk-width-medium-1-2">
              <div className="menu-left-menu-container">
                <ul id="menu-left-menu" className="menu">
                  <li
                    id="menu-item-38"
                    onClick={close_Nav}
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-6 current_page_item menu-item-38"
                  >
                    <Link to="/">
                      {rtl ? "صفحة الإستقبال" : fr ? "Acceuil" : `HOME`}
                    </Link>
                  </li>

                  <li
                    id="menu-item-37"
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-110"
                  >
                    <Link>
                      {rtl
                        ? "تعرف علينا"
                        : fr
                        ? "À propos de nous"
                        : "ABOUT US"}
                    </Link>
                    <ul className="sub-menu">
                      <li
                        onClick={close_Nav}
                        id="menu-item-111"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-111"
                      >
                        <Link to="/about-us">{rtl ? "من نحن" : "MMH LTD"}</Link>
                      </li>
                      <li
                        onClick={close_Nav}
                        id="menu-item-317"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-317"
                      >
                        <Link to="/founder">
                          {rtl
                            ? "الرئيس التنفيذي"
                            : fr
                            ? "Fondateur"
                            : "FOUNDER"}
                        </Link>
                      </li>
                      <li
                        onClick={close_Nav}
                        id="menu-item-111"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-111"
                      >
                        <Link to="/other">
                          {rtl ? "رؤيتنا" : fr ? "Notre vision" : "OUR VISION"}
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li
                    onClick={close_Nav}
                    id="menu-item-110"
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-110"
                  >
                    <Link to="/our-companies">
                      {rtl
                        ? "شركاتنا"
                        : fr
                        ? "Nos entreprises"
                        : "OUR COMPANIES"}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="uk-width-large-1-3 uk-hidden-medium"></div>
            <div className="uk-width-large-1-3 uk-width-medium-1-2">
              <div className="menu-right-menu-container">
                <ul id="menu-right-menu" className="menu">
                  <li
                    onClick={close_Nav}
                    id="menu-item-42"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-42"
                  >
                    <Link to="/services">
                      {rtl ? "خدماتنا" : fr ? "Nos services" : "OUR SERVICES"}
                    </Link>
                  </li>

                  <li
                    onClick={close_Nav}
                    id="menu-item-628"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-628"
                  >
                    <Link to="/careers">
                      {rtl ? "التوظيف" : fr ? "Carrières" : "CAREERS"}
                    </Link>
                  </li>
                  <li
                    onClick={close_Nav}
                    id="menu-item-628"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-628"
                  >
                    <Link to="/contact-us">
                      {rtl ? "للتواصل" : fr ? "Nous contacter" : "CONTACT US"}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <a
        className="uk-icon-bars uk-visible-small"
        onClick={button_menu_target}
        id="button-menu-target"
        data-uk-toggle="{target:'#menu-target', cls: 'uk-hidden-small', animation:'uk-animation-slide-top, uk-animation-slide-bottom'}"
      ></a>
    </header>
  );
};

export default Navbar;
